/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { commonIcon } from "../../asset";
import { CHAT_TYPE } from "../../constants/index";
import { songToSermon } from "../../services/songToSermon";
import { chatAction } from "../../store/chat";
import { sendChatData } from "../../store/chat-action";
import { IconClose, IconPlus, ThreeDotIcon } from "../Ui/Icon";
import styles from "./InputSection.module.css";
import Lang from "./Lang";
import SearchData from "./SearchData";
import { cn } from "../../utils/utils";
import { uiAction } from "../../store/ui-gemini";
import { getConfig } from "../../store/config-action";

const InputSection = () => {
  const MAX_LENGTH = process.env.REACT_APP_MAX_INPUT_CHARACTER || 2000;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLogin = useSelector((state) => state.auth.isLogin);
  const [userInput, setUserInput] = useState("");
  const isLoader = useSelector((state) => state.chat.isLoader);
  const isReplying = useSelector((state) => state.chat.isReplying);
  const chatType = useSelector((state) => state.chat.chatType);

  const userDetails = useSelector((state) => state.user.user);
  const config = useSelector((state) => state.ui.config);
  const messages = useSelector((state) => state.chat.messages);
  const isWelcomeModalOpen = useSelector((s) => s.ui.isWelcomeModalOpen);
  const isShowSlide = useSelector((s) => s.ui.isShowSlide);
  const isLoginRequiredModalOpen = useSelector((s) => s.ui.isLoginRequiredModalOpen);
  const shouldShowAuthButtons =
    !userDetails.id &&
    (messages?.length === 2 || messages?.length === 4) &&
    !isLoader &&
    !isReplying &&
    !isWelcomeModalOpen &&
    !isLoginRequiredModalOpen &&
    !isShowSlide;


  const previousChat = useSelector((state) => state.chat.previousChat);
  const chatHistoryId = useSelector((state) => state.chat.chatHistoryId);
  const suggestPrompt = useSelector((state) => state.chat.suggestPrompt);


  const [showDropdown, setShowDropdown] = useState(false);
  const [selectDropdown, setSelectDropdown] = useState("");
  const [query, setQuery] = useState("");
  const [queryData, setQueryData] = useState([]);

  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);
  const formRef = useRef(null);

  const userInputHandler = (e) => {
    setUserInput(e.target.value?.slice(0, MAX_LENGTH));
    if (selectDropdown) {
      setQuery(e.target.value);
    }
  };

  // Custom debounce hook
  const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      return () => {
        clearTimeout(handler);
      };
    }, [value, delay]);

    return debouncedValue;
  };
  const debouncedSearchTerm = useDebounce(query, 500);
  const searchAndOpenVideo = useCallback(async (query) => {
    console.log(query);
    if (!query) {
      setQueryData([]);
      return;
    }
    try {
      const response = await songToSermon({ text: query });

      if (
        response.data &&
        response.data.data &&
        response.data.data.length > 0
      ) {
        setQueryData(response.data.data);
      } else {
        console.log("No video found!");
      }
    } catch (error) {
      console.log(error);
    }
  }, []);
  useEffect(() => {
    searchAndOpenVideo(debouncedSearchTerm);
  }, [debouncedSearchTerm]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false); // close when clicked outside
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const onSubmitHandler = (e) => {
    e.preventDefault();
    dispatch(
      sendChatData({
        chatType,
        user: userInput,
        gemini: "",
        isLoader: "yes",
        previousChat,
        chatHistoryId,
      }, isLogin)
    );
    setUserInput("");
    setQuery("");
    if(isLogin){
      navigate("/home/app");
    }
  };

  useEffect(() => {
    // Ensure global config is loaded so placeholder comes from DB, not fallback
    if (!userDetails?.config?.landingPlaceHolder && !config?.landingPlaceHolder) {
      dispatch(getConfig());
    }
  }, []);

  useEffect(() => {
    if (suggestPrompt.length > 0) {
      setUserInput(suggestPrompt);
      if (selectDropdown) {
        setQuery(selectDropdown);
      }
    }
  }, [suggestPrompt]);

  const handleStop = () => {
    setTimeout(() => {
      dispatch(chatAction.setIsStoped(true));
    }, 1000);
  };

  const cssStype = userInput ? "opacity-70" : "opacity-10";
  const placeholder =
    userDetails?.config?.landingPlaceHolder ??
    config?.landingPlaceHolder ??
    "Ask anything to begin"
 

  const handleDropdownToggle = () => setShowDropdown((prev) => !prev);

  const Dropdown = () => {
    return (
      <ul
        ref={dropdownRef}
        className={cn("text-start absolute bottom-full bg-white border-solid border rounded-lg shadow-md z-10 p-1 list-none",
          showDropdown ? "visible" : "hidden"
        )}
      >
        <li
          onDoubleClick={() => {
            setSelectDropdown("Song to Sermon");
          }}
          data-tour="song-to-sermon"
          onClick={() => {
            if(!isLogin){
              dispatch(uiAction.openLoginRequiredModal());
              return;
            }
            setSelectDropdown("Song to Sermon");
            handleDropdownToggle();
          }}
          className="flex items-center gap-0.5 py-2 px-4 rounded-lg cursor-pointer hover:bg-[var(--input-focus-bg)]"
        >
          <img className="w-5 h-5" src={commonIcon.ytIcon} alt="icon"></img>
          <span
            className={`${
              selectDropdown === "Song to Sermon" ? "text-[#0285ff]" : ""
            }`}
          >
            Song to Sermon
          </span>
        </li>
        {window.innerWidth < 768 && (
        <li
         data-tour="language-selector-mobile" className="flex md:hidden items-center gap-0.5 py-2 px-4 rounded-lg cursor-pointer hover:bg-[var(--input-focus-bg)]">
            <ThreeDotIcon className="w-5 h-5" />
            <Lang className="" />
          </li>
        )}
      </ul>
    );
  };

  const StopButton = () => {
    return (
      <button
        type="button"
        className="btn-stop opacity-70 hover:opacity-100"
        onClick={handleStop}
      >
        <img
          className="w-8 h-8"
          src={commonIcon.stopIcon}
          alt="stop icon"
        ></img>
      </button>
    );
  };

  const SubmitButton = ({ className }) => {
    return (
      <button
        data-tour="send-button"
        disabled={isLoader || isReplying || !userInput}
        type="submit"
        className={`btn-input ${cssStype} disabled:cursor-default enabled:hover:opacity-100`}
      >
        <img
          className="w-8 h-8 transform rotate-4"
          src={commonIcon.sendIcon}
          alt="send icon"
        ></img>
      </button>
    );
  };

  const triggerSubmit = () => {
    // formRef.current?.requestSubmit();
    // setQueryData([]);
  };

  return (
    <div className="">
       {shouldShowAuthButtons && (
        <div className="absolute md:px-0 px-8 w-full bottom-[120px] z-20  mx-0 max-w-[830px] left-[50%] transform -translate-x-1/2">
          <div className="border border-gray-200 bg-white rounded-2xl p-4 md:p-5 shadow-sm">
            <div className="flex flex-col md:flex-row sm:justify-center md:items-center items-center md:justify-center lg:justify-between gap-4">
              <p className="text-[15px]  text-gray-700 pr-2 flex-1">
                Get smarter responses, upload files and images, and more.
              </p>
              <div className="grid grid-cols-1 grid-rows-2 gap-3 w-full md:max-w-[200px]">
                <button
                  onClick={() => (window.location.href = "/login")}
                  className="w-full py-2 rounded-full bg-[#14A6EA] text-white hover:bg-gray-800 active:scale-[0.98]"
                >
                  Log in
                </button>
                <button
                  onClick={() => (window.location.href = "/signup")}
                  className="w-full py-2 rounded-full bg-white border border-gray-300 text-gray-900 hover:bg-gray-50 active:scale-[0.98]"
                >
                  Sign up for free
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div
        className={`${styles["input-main"]} rounded-lg ${
          selectDropdown ? "h-[88px]" : ""
        }`}
      >
        <form
          ref={formRef}
          id="input-form-chat"
          onSubmit={onSubmitHandler}
          className="flex items-center relative"
        >
          {!selectDropdown && (
            <div
              id="plus-button"
              ref={buttonRef}
              type="button"
              onClick={handleDropdownToggle}
              className={`flex cursor-pointer items-center justify-center w-8 h-8 !left-2 relative p-1 rounded-full hover:bg-white`}
            >
              <IconPlus size="10" className="" />
            </div>
          )}
          {Dropdown()}
          {queryData.length > 0 && (
            <SearchData
              data={queryData}
              setQueryData={setQueryData}
              onClickLink={triggerSubmit}
            ></SearchData>
          )}
          <input
            data-tour="input"
            disabled={isLoader}
            onChange={userInputHandler}
            autoComplete="off"
            type="text"
            placeholder={placeholder}
            name="prompt"
            value={userInput}
            autoFocus
          ></input>
          <div className="flex cursor-pointer gap-3 justify-between items-center absolute right-4">
            <div data-tour="language-selector-desktop">
              <Lang className="hidden md:block" />
            </div>
            {isReplying ? <StopButton /> : <SubmitButton />}
          </div>
        </form>
        {selectDropdown && (
          <div className="absolute w-full -bottom-2.5 flex justify-between items-center p-2.5">
            <div className="flex justify-between items-center gap-1">
              <div
                ref={buttonRef}
                type="button"
                onClick={handleDropdownToggle}
                className={`flex cursor-pointer justify-center items-center w-8 h-8 hover:bg-white -bottom-2.5 p-1 rounded-full`}
              >
                <IconPlus size="10" />
              </div>
              <span className="text-slate-300">|</span>
              <label className="text-[#0285ff] gap-0.5 text-sm hover:text-[#0172b867] cursor-pointer flex items-center">
                <img
                  className="w-4 h-4"
                  src={commonIcon.ytIcon}
                  alt="icon"
                ></img>
                {selectDropdown}
              </label>
              <IconClose
                onClick={() => setSelectDropdown("")}
                size="5"
                className="cursor-pointer text-[#0285ff] hover:text-[#0172b8]"
              />
            </div>
          </div>
        )}
        {userInput && (
          <p
            className={`flex items-center absolute right-0 ${
              selectDropdown ? "-bottom-2.5" : "-bottom-8"
            } text-red-500 p-2.5 text-sm opacity-90 text-left md:text-right`}
          >
            {MAX_LENGTH - userInput.length} characters left
          </p>
        )}
      </div>
    </div>
  );
};

export default InputSection;
